module.exports = __webpack_public_path__ + "img/gnu_smart_gallery7.d09df801.jpg";